import type {FC} from 'react'
import {Link} from 'react-router-dom'
import {useQueryClient, useMutation} from 'react-query'
import {toast} from 'react-toastify'
import {putTransactionRecords} from '../../../modules/services/transactions.service'
import getPageList from '../../../utils/getPageList'
import getValueFromObj from '../../../utils/getValueFromObj'

interface Props {
  head: string[]
  body: Array<string | {text: string; truncate?: number}>
  data: Array<any> | undefined
  href?: string
  allPaginate?: number
  page?: number
  setsPage?: (e: any) => void
  nextPage?: () => void
  prevPage?: () => void
  isReverse?: boolean
}

const TableTransaction: FC<Props> = ({
  head,
  body,
  data,
  href,
  allPaginate = null,
  page,
  setsPage,
  nextPage,
  prevPage,
  isReverse,
}) => {
  const queryClient = useQueryClient()
  const mutation = useMutation(putTransactionRecords, {
    onSuccess: () => {
      queryClient.invalidateQueries('getListTransactionRecords')
      toast.success('Success')
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message)
    },
  })

  const handleAction = (id: string | null, status: string) => {
    mutation.mutate({
      id,
      data: {
        status,
      },
    })
  }
  const pageNumbers = getPageList(allPaginate!, page!, 9)

  return (
    <div className='p-8'>
      <table className='table table-hover table-rounded table-striped border gy-7 gs-7'>
        <thead>
          <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
            {head.map((item, index) => (
              <th key={index}>{item}</th>
            ))}
            <th className='text-end'>Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index}>
              {body.map((obj, i) => (
                <td key={i}>
                  {getValueFromObj(typeof obj === 'string' ? obj : obj.text, item)
                    ?.toString()
                    .substring(0, typeof obj === 'string' ? undefined : obj?.truncate)}
                  {typeof obj !== 'string' && obj?.truncate ? '...' : ''}
                </td>
              ))}
              <td className='d-flex gap-4 justify-content-end text-end'>
                <Link to={`/${href}/${item.id}`}>
                  <button className='btn btn-sm btn-light-primary'>View</button>
                </Link>
                {isReverse ? (
                  <button
                    onClick={() => handleAction(getValueFromObj('id', item), 'waiting')}
                    className='btn btn-sm btn-light-info'
                  >
                    Reverse
                  </button>
                ) : (
                  <>
                    <button
                      onClick={() => handleAction(getValueFromObj('id', item), 'valid')}
                      className='btn btn-sm btn-light-success'
                    >
                      Valid
                    </button>
                    <button
                      onClick={() => handleAction(getValueFromObj('id', item), 'invalid')}
                      className='btn btn-sm btn-light-danger'
                    >
                      Invalid
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ul className='pagination'>
        <li className='page-item previous'>
          <button className='page-link' onClick={() => prevPage!()}>
            <i className='previous'></i>
          </button>
        </li>
        {pageNumbers.map((num, i) =>
          num === 0 ? (
            <li key={i} className='page-item'>
              <button className='page-link'>...</button>
            </li>
          ) : (
            <li key={i} className='page-item'>
              <button
                className={`page-link ${num === page ? 'active' : ''}`}
                onClick={() => setsPage?.(num)}
              >
                {num}
              </button>
            </li>
          )
        )}
        <li className='page-item next'>
          <button className='page-link' onClick={() => nextPage!()}>
            <i className='next'></i>
          </button>
        </li>
      </ul>
    </div>
  )
}

export default TableTransaction
